import React from 'react';
import ImportantDocumentToAccept from './ImportantDocumentToAccept';
import TermsOfUseInput from './TermsOfUseInput';

const OwnerTermsOfUsePendingRequest = ({ ownerTermsOfUsePendingChangeRequest }) => {
  return (
    <>
      {ownerTermsOfUsePendingChangeRequest.map((req) => (
        <div key={req.id}>
          <ImportantDocumentToAccept pendingChangeRequest={req} />
          <br />
          <TermsOfUseInput inputName="ownerTermsOfUseStatus"/>
        </div>
      ))}
    </>
  );
};

export default OwnerTermsOfUsePendingRequest;
